import Box from 'grommet/components/Box';
import CheckBox from 'grommet/components/CheckBox';
import Button from 'grommet/components/Button';
import React from 'react';
import Form from 'grommet/components/Form';
import FormFields from 'grommet/components/FormFields';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import {
    linealregressionsample, 
    databar, 
    multipleArrays3,
    dataDonut,
    anomaly,
    logisticregressionsample,
    histogram,
    multilinealregressionsample,
    multillogisticregressionsample
} from "./samples"
import Select from 'grommet/components/Select';

const data = [{
    title: "Data or Train Data.. Create Data Exploration and Fit Modal",
    content: "textarea"
}]

class DonutData extends React.Component {
    constructor(props) {
        super(props);
        this._onClick = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this.state = { 
            dataInput: linealregressionsample,//props.dataObject ? props.rows > 10000 ? "Long data set. Use file or URL tab to reload data" : props.dataObject : linealregressionsample,
            predefinedValues: "Linear Regression", 
            splitData: "80%-20%",
            type: "Array<Array>"
        } 
    }
    componentDidMount() {
        
        
    }
    //This one breaks Optios Data since is not multidimensional array. Change to previos format. Move this to Anomaly.
    
    
    _onClick(dataJsonParsed) {
        const {splitData, predefinedValues} = this.state;
        if (dataJsonParsed !== "Long data set. Use file or URL tab to reload data") {
            let dataObjectParsed;
            if (predefinedValues === "Anomaly Analysis") {
                //dataObjectParsed = this.parseObjectFromString(dataJsonParsed)
                dataObjectParsed = JSON.parse(dataJsonParsed.replace(/(\r\n|\n|\r|\s)/gm,""));
            } else {
                dataObjectParsed = JSON.parse(dataJsonParsed.replace(/(\r\n|\n|\r|\s)/gm,""));
            }
            this.props.onSubmit(dataObjectParsed, splitData)
        }
    }


    _onChange(event) {
        this.setState({dataInput: event.target.value})
    }
    _onChangeSelect(field) {
        //const {dataInput, predefinedValues} = this.state;
        //['Descriptive Metrics', 'Multiple Scatter', 'Boxplots', 'Linear Regression', 'Logistic Regression', 'Anomaly Analysis']
        if (field.value === "Descriptive Metrics" ||
            field.value === "Multiple Scatter" ||
            field.value === "Boxplots" ) {
          this.setState({dataInput: multipleArrays3, predefinedValues: field.value, type: "Array<Array>"})
        } else if (field.value === "Linear Regression") {
          this.setState({dataInput: linealregressionsample, predefinedValues: field.value, type: "Array<Array>  Note: Last array is the independent variable (y)"})
        } else if (field.value === "Logistic Regression") {
          this.setState({dataInput: logisticregressionsample, predefinedValues: field.value, type: "Array<Array> Note: Last array is the independent variable (y) and can only have 0 and 1 values"})
        } else if (field.value === "Anomaly Analysis") {
          this.setState({dataInput: anomaly, predefinedValues: field.value, type: "Array<Array<String || Number>> Note: Last array is the independent variable (y)" })
        } else if (field.value === "Histogram") {
            this.setState({dataInput: histogram, predefinedValues: field.value, type: "Array<Array>"})
        } else if (field.value === "Multi Linear Regression") {
            this.setState({dataInput: multilinealregressionsample, predefinedValues: field.value, type: "Array<Array> Note: Last array is the independent variable (y)"})
        } else if (field.value === "Multi Logistic Regression") {
            this.setState({dataInput: multillogisticregressionsample, predefinedValues: field.value, type: "Array<Array> Note: Last array is the independent variable (y) and can only have 0 and 1 values"})
        }
    }
    _onChangeSplit(field) {
        this.setState({splitData: field.value})
    }
    render() {
        
        const { dataInput, predefinedValues, type, splitData} = this.state;
        // dataInputParsed = dataInput ? JSON.parse(dataInput.replace(/(\r\n|\n|\r|\s)/gm,"")) : {}       
        let numberOfRows = 8;
        let titleData;

        if (this.props.currentElement === "Anomaly Analysis GPU") {
            //numberOfRows = 8;
            titleData = "Type: Array<Array<String || Number>>"
            
        } else {
            //numberOfRows = 2;
            titleData = "Type: Array<Array<Number>>"   
        }
        const showSplit = (predefinedValues === "Linear Regression" ||
        predefinedValues === "Logistic Regression" ||
        predefinedValues === "Anomaly Analysis" ||
        predefinedValues === "Multi Linear Regression" ||
        predefinedValues === "Multi Logistic Regression") ? true : false
        //options={['Descriptive Metrics', 'Multiple Scatter', 'Boxplots', 'Linear Regression', 'Logistic Regression', 'Anomaly Analysis', 'Histogram', 'Multi Linear Regression', 'Multi Logistic Regression']}
        let content = (<div>
                            <div>
                                <Box direction='row'
                                    justify='start'
                                    align='center'
                                    wrap={true}
                                    pad='medium'
                                    reverse={false}
                                    margin='none'>
                                    <Box direction='row'
                                        align='center'
                                        wrap={true}
                                        pad='medium'
                                        margin='none'>
                                        <strong>Predefined </strong> &nbsp; datasets for: &nbsp; &nbsp;
                                        <Select placeHolder='None'
                                            options={['Linear Regression', 'Logistic Regression', 'Anomaly Analysis', 'Multi Linear Regression', 'Multi Logistic Regression']}
                                            placeHolder={"Type"}
                                            value={predefinedValues}
                                            onChange={this._onChangeSelect.bind(this)} />
                                     </Box>
                                     { showSplit && <Box direction='row'
                                        align='center'
                                        wrap={true}
                                        pad='medium'
                                        margin='none'>
                                        Split (%) Train vs Test &nbsp; &nbsp;
                                        <Select placeHolder='None'
                                            options={['80%-20%']}
                                            placeHolder={"Type"}
                                            value={splitData}
                                            onChange={this._onChangeSplit.bind(this)} />
                                     </Box>}
                                </Box>

                                <Box direction='row'
                                    justify='start'
                                    align='left'
                                    wrap={true}
                                    reverse={false}
                                    margin='none'>
                                    <Box direction='row'
                                        align='left'
                                        wrap={true}
                                        pad='small'
                                        margin='none'>
                                        <h4>Type: {type}</h4>
                                        </Box>
                        
                                    </Box>

                                <textarea 
                                    id={`textarea-0`} 
                                    name={`textarea-0`}
                                    rows={numberOfRows} 
                                    style={{width: "100%"}}
                                    placeholder={dataInput}
                                    value={dataInput}
                                    onChange={this._onChange.bind(this)}
                                    >
                                </textarea>
                            </div>
            </div>)
        
        return (
            <div>
                 <Box direction='row'
                                    justify='start'
                                    align='left'
                                    wrap={true}
                                    reverse={false}
                                    margin='none'>
                                    <Box direction='row'
                                        align='left'
                                        wrap={true}
                                        pad='small'
                                        margin='none'>
                <div style={{ right: "40px", position: "absolute", marginRight: "10px"}}>
                <Button 
                    label='Submit'
                    type='submit'
                    primary={true}
                    onClick={this._onClick.bind(this, dataInput)} 
                />
                </div>
                </Box>
                </Box>
            
                {content} 
            </div>
        );
    }
}

export default DonutData;



// WEBPACK FOOTER //
// ./src/samples/data/manualinput.js